import React from 'react';
import Cover from './Cover';
import DataCovers from './API_Covers';

export class __Covers extends React.Component {

  componentDidMount() {
    var linkWithRef = window.location.href.indexOf("?refbook=");

    if (linkWithRef !== -1) {
      var refBook = window.location.href.substr(linkWithRef + 9);
      var offset = document.getElementById(refBook).offsetTop-100;
      setTimeout(() => {
        window.scrollTo(0, offset);
      }, 1);
    }
  }

  render () {
    return (
      <div className="content fading">
        <h1>Covers</h1>
        <p className="subtitle">Design of a cover can be really personal for the child, e.g. with the child's name on it or cute character, etc. You can choose one from this gallery or simply describe own vision of your personal cover design.</p>
        <section>
          <ul className="pages">
            {
              DataCovers.all().filter(p => !p.img).map((p) => <Cover key={p.number} type={p.type} id={p.name} class={p.label} title={p.name} descr={p.descr} />)
            }
          </ul>
        </section>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/__Covers.js